// extracted by mini-css-extract-plugin
export var chevron = "_m2-3";
export var chevronRotated = "_m2-4";
export var image = "_m2-1";
export var imageContainer = "_m2-0";
export var shippingAddress = "_m2-2";